
import { IFormActions, IFormState, IFormSubscription, useFieldActions, useFieldState, useFormActions, useFormState } from "@ngt/forms-core";
import { useContext, useEffect, useMemo, ReactNode, MouseEvent, useCallback } from "react";
import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import FormActionButton, { IFormActionButtonProps } from "./FormActionButton";
import { FormError } from '../../errors';

export interface IFormSubmitButtonProps<T extends object = any> extends Omit<IFormActionButtonProps<T>, 'onClick'> {
    onClick?: IFormActionButtonProps<T>['onClick']
    
}

const defaultSubscription = { submitting: true, validating: true };

const FormSubmitButton = <T extends object = any>({
    onClick,
    loading,
    loadingSubscription,
    ...rest
}: IFormSubmitButtonProps<T>) => {
    const click = useMemo(() => {
        if (!onClick) {
            return async (event: MouseEvent<HTMLButtonElement>, actions: IFormActions) => {
                await actions.submit();
            };
        }

        return onClick
    }, [onClick]);

    const loadingToUse = useMemo(() => {
        if (loading != undefined) {
            return loading;
        }

        return (formState: IFormState<T, FormError>) => {
            return formState.submitting || formState.validating;
        };
    }, [loading])

    return (
        <FormActionButton
            {...rest}
            type="submit"
            onClick={click}
            loading={loadingToUse}
            loadingSubscription={loading !== undefined || !!loadingSubscription ? loadingSubscription : defaultSubscription}
        />
    )
};

export default FormSubmitButton;